import { useStorage } from "../useStorage";

export function useFeatureFlag(featureFlagKey: string) {
  const [isFeatureFlag] = useStorage(featureFlagKey, false);

  return isFeatureFlag;
}
